import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import LoadingButton from "components/LoadingButton";
import MDButton from "components/MDButton";
import Dialog from "components/NoScrollDialog";
import { useEffect, useState } from "react";
import auditsService from "services/audits-service";
import useLoading from "utils/useLoading";

export default function AuditNarrativeDialog({ audit, refresh }) {
  const [updated, setUpdated] = useState({});
  const { loading, changeLoading } = useLoading({
    submit: false,
  });
  const [open, setOpen] = useState(false);

  async function onSubmit() {
    changeLoading("submit", true);
    const data = { ...updated };

    if (Object.keys(data).length > 0) {
      const [response] = await auditsService.updateAudit(audit.id, data);

      if (!response.ok) {
        return { error: true };
      }
    }

    await refresh();

    setUpdated({});
    changeLoading("submit", false);

    return { success: true };
  }

  useEffect(() => {
    setUpdated({ ...updated, narrativeText: audit.narrativeText });
  }, [audit]);

  if (audit.auditTypeId != 2) return;

  return (
    <>
      <MDButton
        variant="gradient"
        color="info"
        onClick={() => {
          setOpen(true);
        }}
        size="small"
      >
        Narrative
      </MDButton>
      <Dialog
        open={open}
        maxWidth={"lg"}
        onClose={() => {
          setOpen(false);
        }}
        fullWidth
        PaperProps={{
          component: "form",
          onSubmit: async (event) => {
            event.preventDefault();

            changeLoading("submit", true);

            const result = await onSubmit(updated);
            if (result.success) {
              setOpen(false);
            }

            changeLoading("submit", false);
          },
        }}
      >
        <DialogTitle>Edit Narrative</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            minRows={6}
            fullWidth
            label="Narrative"
            value={updated.narrativeText}
            onChange={(e) => {
              setUpdated({ ...updated, narrativeText: e.target.value });
            }}
            sx={{ mt: 0.6 }}
          />
          {audit.narrativeAttachment?.url ? (
            <Box sx={{ mt: 2 }}>
              <audio
                controls
                preload="metadata"
                src={audit.narrativeAttachment.url}
                style={{ width: "100%" }}
              >
                Your browser does not support audio playback.
              </audio>
            </Box>
          ) : null}
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            justifyContent: "end",
          }}
        >
          <MDButton
            onClick={() => {
              setOpen(false);
            }}
          >
            Cancel
          </MDButton>
          <LoadingButton
            loading={loading.submit}
            type="submit"
            variant="gradient"
            color="info"
          >
            Save
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
